/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CareUnitSettings
 */
export interface CareUnitSettings {
    /**
     * 
     * @type {string}
     * @memberof CareUnitSettings
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CareUnitSettings
     */
    careUnitId?: string;
    /**
     * 
     * @type {string}
     * @memberof CareUnitSettings
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof CareUnitSettings
     */
    cardTypeId?: string;
}

export function CareUnitSettingsFromJSON(json: any): CareUnitSettings {
    return CareUnitSettingsFromJSONTyped(json, false);
}

export function CareUnitSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CareUnitSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'careUnitId': !exists(json, 'careUnitId') ? undefined : json['careUnitId'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'cardTypeId': !exists(json, 'cardTypeId') ? undefined : json['cardTypeId'],
    };
}

export function CareUnitSettingsToJSON(value?: CareUnitSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'careUnitId': value.careUnitId,
        'carePrincipalId': value.carePrincipalId,
        'cardTypeId': value.cardTypeId,
    };
}

